import * as actionTypes from '../actionTypes';
import axios from '../../../services/axios'
import {setMessage} from "../message";

export const loadPersonalRating = () => {
    return {
        type: actionTypes.LOAD_PERSONAL_RATING_DATA
    }
}

export const setPersonalRating = (personalRatingData) => {
    return {
        type: actionTypes.SET_PERSONAL_RATING_DATA,
        personalRatingData: personalRatingData
    }
}

export const getPersonalRating = (id, subgroup) => {
    return (dispatch) => {
        dispatch(loadPersonalRating())
        axios.get(`/api/v1/grade-book` + ((id === null || id === undefined) ? `` : `/${id}`) + ((subgroup === null || subgroup === undefined) ? `` : `/${subgroup}`))
            .then(response => {
                dispatch(setPersonalRating(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const loadIsGroupHead = () => {
    return {
        type: actionTypes.LOAD_IS_GROUP_HEAD
    }
}

export const setIsGroupHead = (isGroupHead) => {
    return {
        type: actionTypes.SET_IS_GROUP_HEAD,
        isGroupHead: isGroupHead
    }
}

export const getIsGroupHead = () => {
    return (dispatch) => {
        dispatch(loadIsGroupHead())
        axios.get(`/api/v1/grade-book/is-group-head`)
            .then(response => {
                dispatch(setIsGroupHead(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const loadWhoCanNote = () => {
    return {
        type: actionTypes.LOAD_WHO_CAN_NOTE
    }
}

export const setWhoCanNote = (whoCanNote) => {
    return {
        type: actionTypes.SET_WHO_CAN_NOTE,
        whoCanNote: whoCanNote
    }
}

export const getWhoCanNote = () => {
    return (dispatch) => {
        dispatch(loadWhoCanNote())
        return axios.get(`/api/v1/grade-book/who-can-note`)
            .then(response => {
                dispatch(setWhoCanNote(response.data))
            })
            .catch(error => {
                dispatch(setMessage({type: 'warning', text: "Не удалось подключиться к серверу."}))
            });
    }
}

export const removeAssignResponsible = (ids, responsible) => {
    return (dispatch) => {
        return axios.post(`/api/v1/grade-book/remove-responsible`, ids)
            .then(_response => {
                const tmp = responsible.filter(item => !ids.includes(item))
                dispatch(setWhoCanNote(tmp))
            })
    }
}

export const sendAssignResponsible = () => {
    return {
        type: actionTypes.SEND_ASSIGN_RESPONSIBLE
    }
}

export const receiveSendAssignResponsible = () => {
    return {
        type: actionTypes.RECEIVE_SEND_ASSIGN_RESPONSIBLE,
    }
}

export const postAssignResponsible = (gradeBookResponsibleDto) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch(sendAssignResponsible())
        axios
            .post(`/api/v1/grade-book/assign-responsible`, gradeBookResponsibleDto)
            .then((response) => {
                dispatch(receiveSendAssignResponsible());

                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    });

export const sendCreateOmission = () => {
    return {
        type: actionTypes.SEND_CREATE_OMISSION
    }
}

export const receiveSendCreateOmission = () => {
    return {
        type: actionTypes.RECEIVE_CREATE_OMISSION,
    }
}

export const postCreateOmission = (gradeBookOmissionRequestDto) => (dispatch) =>
    new Promise(function (resolve, reject) {
        dispatch(sendCreateOmission())
        axios
            .post(`/api/v1/grade-book/create`, gradeBookOmissionRequestDto)
            .then((response) => {
                dispatch(setMessage({type: 'success', text: "Пропуски успешно выставлены."}))
                dispatch(receiveSendCreateOmission());

                resolve();
            })
            .catch((error) => {
                dispatch(setMessage({type: 'error', text: "Не удалось выставить пропуски."}))
                reject(error);
            });
    });
